'use client';

import { cn } from 'cn';
import { useTranslations } from 'use-intl';

import GridShuffleLoading from './shared-ui-grid-shuffle-loading';
import { useDelayedLoadingFlag } from './ui.video-player-loading.hooks';
import { SLOW_LOADING_HINT_MS } from './ui.video-player.consts';
import type { VideoPlayerLoadingOverlayVariant } from './ui.video-player.types';

interface Props {
  variant: VideoPlayerLoadingOverlayVariant;
  className?: string;
}

export function VideoPlayerLoadingOverlay({ variant, className }: Props) {
  const t = useTranslations('VideoPlayer');
  const showSlowHint = useDelayedLoadingFlag(true, SLOW_LOADING_HINT_MS);

  return (
    <output
      data-test='video-player-loading-overlay'
      data-variant={variant}
      aria-live='polite'
      className={cn(
        'absolute inset-0 z-50 flex items-center justify-center p-4 data-[variant=buffering]:bg-black/50 data-[variant=cover]:bg-gray-800',
        className
      )}
    >
      <GridShuffleLoading className='size-16 text-gray-200' />
      {showSlowHint ? (
        <span
          data-test='video-player-slow-loading-hint'
          className='absolute bottom-4 left-1/2 flex min-h-6 -translate-x-1/2 items-center justify-center rounded-lg bg-gray-900 px-3 py-2 text-xs/4 font-semibold whitespace-nowrap text-gray-100'
        >
          {t('loadingVideo')}
        </span>
      ) : null}
    </output>
  );
}
